module.exports = __webpack_public_path__ + "img/vertical_6_1_5010.de659528.png";